import { j as o } from "../../../jsx-runtime-CQ7OqOhn.js";
import { carouselStyles as s } from "./Carousel.styles.js";
import "../../atoms/Button/Button.styles.js";
import "@fortawesome/pro-duotone-svg-icons";
import a from "../../atoms/Icon/Icon.js";
import l from "../../../tailwindConfig/bclTwMerge.js";
import c from "../../atoms/Button/IconButton/IconButton.js";
import "@radix-ui/react-checkbox";
import "../../atoms/Checkbox/Checkbox.styles.js";
import "@fortawesome/pro-solid-svg-icons";
import "../../atoms/Loader/SYFLoader/SyfLoader.js";
import "../../atoms/ProgressIndicator/ProgressIndicator.styles.js";
import "react";
import "@radix-ui/react-select";
import "../../atoms/TextField/TextField.styles.js";
import "../../atoms/TextLink/TextLink.styles.js";
import "../../atoms/Chip/Chip.styles.js";
import "@radix-ui/react-radio-group";
import "../../atoms/RadioItem/RadioItem.styles.js";
import "../../../tailwindConfig/colors/index.js";
import "../../../tailwindConfig/fontSize/fontSize.js";
import "../../../tailwindConfig/plugins/gradientUtilities.plugin.js";
import "../../../tailwindConfig/plugins/rootStyles.plugin.js";
import "@tailwindcss/container-queries";
import "@tailwindcss/aspect-ratio";
const D = ({
  ariaLabel: r,
  arrowButtonStyle: t,
  icon: m,
  onClick: i,
  dataTestId: p
}) => {
  const { carouselButton: e } = s;
  return /* @__PURE__ */ o.jsx(
    c,
    {
      color: "secondary",
      iconName: "Slider arrow",
      onClick: i,
      className: l(e, t),
      "aria-label": r,
      "data-testid": p,
      children: /* @__PURE__ */ o.jsx(a, { icon: m, className: "size-6 pt-1" })
    }
  );
};
export {
  D as default
};
